(function () {
  var el = document.getElementById('LinePopup');
  if (!el) return;

  var prefix = el.dataset.storagePrefix || 'yw_line_popup_v1';
  var delayMs = (parseInt(el.dataset.delaySeconds, 10) || 15) * 1000;
  var silentDays = parseInt(el.dataset.silentDays, 10) || 7;

  var KEY_PERMANENT = prefix + '_permanent_hide';
  var KEY_UNTIL = prefix + '_dismissed_until';

  function safeGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, val) {
    try { window.localStorage.setItem(key, val); } catch (e) {}
  }

  if (safeGet(KEY_PERMANENT) === '1') return;

  var until = parseInt(safeGet(KEY_UNTIL) || '0', 10);
  if (until && Date.now() < until) return;

  function open() {
    el.hidden = false;
    // trigger transition on next frame
    requestAnimationFrame(function () {
      el.setAttribute('data-visible', 'true');
    });
    document.addEventListener('keydown', onKey);
  }

  function close(permanent) {
    el.removeAttribute('data-visible');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { el.hidden = true; }, 260);
    if (permanent) {
      safeSet(KEY_PERMANENT, '1');
    } else {
      var ms = silentDays * 24 * 60 * 60 * 1000;
      safeSet(KEY_UNTIL, String(Date.now() + ms));
    }
  }

  function onKey(e) {
    if (e.key === 'Escape') close(false);
  }

  el.querySelectorAll('[data-line-popup-close]').forEach(function (n) {
    n.addEventListener('click', function () { close(false); });
  });

  var cta = el.querySelector('[data-line-popup-cta]');
  if (cta) {
    cta.addEventListener('click', function () {
      // クリックしたら「もう友だち」扱いで恒久非表示
      close(true);
    });
  }

  var timerId = setTimeout(open, delayMs);
  // ページ離脱時はタイマー止める
  window.addEventListener('pagehide', function () { clearTimeout(timerId); });
})();
